import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { seguradorasModuleName, seguradorasStorage } from "../shared/data.service";
import { Seguradora } from "../shared/seguradora.model";
import { PessoaJuridica } from "../../../recursos-humanos/pessoa-juridica/shared/pessoa-juridica.model";
import { SeguradoraNavigationService } from "../shared/seguradora-navigation.service";
import { SeguradoraApiService } from "../shared/seguradora-api.service";
import { SeguradoraService } from "../shared/seguradora.service";
import { PessoaJuridicaApiService } from "../../../recursos-humanos/pessoa-juridica/shared/pessoa-juridica-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { newRouteFemale, editRoute } from "../../../shared/services/data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { PessoaJuridicaService } from "../../../recursos-humanos/pessoa-juridica/shared/pessoa-juridica.service";
import { segurosModuleName } from "../../seguros/shared/data.service";

@Component({
    selector: 'app-seguradora-form',
    template: require('./seguradora-form.component.html'),
    styles: [require('./seguradora-form.component.css')]
})
export class SeguradoraFormComponent implements OnInit {
    module: any = segurosModuleName;
    moduleSeguradora: any = seguradorasModuleName;
    formObject: any = new Seguradora();
    pessoaJuridicaObject: any = new PessoaJuridica();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;

    form: FormGroup;
    ativo = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseSeguradora: any;
    private formObjectToSave: Seguradora;

    constructor(
        private _route: ActivatedRoute,
        private _seguradoraNavigationService: SeguradoraNavigationService,
        private _seguradoraApiService: SeguradoraApiService,
        private _seguradoraService: SeguradoraService,
        private _pessoaJuridicaApiService: PessoaJuridicaApiService,
        private _pessoaJuridicaService: PessoaJuridicaService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:Seguradora = this._utilService.cloneObject(this.formObject);

            this.formObjectToSave = object;
            this.pessoaJuridicaObject.ativo = object.ativo;
            this._pessoaJuridicaService.onSubmit(this.pessoaJuridicaObject, this.onDonePessoaJuridica);
        }
    }

    private onDonePessoaJuridica = (function (Response) {
        if (!Response.error)  {
            var pessoaJuridicaId: number = Response.id;
            this.formObjectToSave.pessoaJuridicaId = pessoaJuridicaId;
            this.formObjectToSave.nome = Response.razaoSocial;

            if (this.formObject.id) {
                this.onEditSeguradora();
            } else {
                this.onAddSeguradora();
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));


    private onAddSeguradora() {
        this._seguradoraApiService.onPost(this.formObjectToSave, this.onDone);
    }

    private onEditSeguradora() {
        this._seguradoraApiService.onPut(this.formObjectToSave, this.onDone);
    }

    private onDone = (function (Response) {
        if (!Response.error)  {
            this.responseSeguradora = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();

            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma seguradora encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._seguradoraApiService.onGetById(id, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._seguradoraService.getSessionStorage();
        this._seguradoraService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(seguradorasStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;

            //qndo vier de outro formulario, setar o objeto de pessoa juridica
            this.pessoaJuridicaObject.razaoSocial = newAutoComplete.nome;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setModelToForm() {
        if (this.formObject.pessoaJuridica) {
            this.pessoaJuridicaObject = this._utilService.cloneObject(this.formObject.pessoaJuridica);
            delete this.formObject['pessoaJuridica'];
        }
    }

    private goToList() {
        this._seguradoraNavigationService.goToList();
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._seguradoraService.returnToOtherForm(this.otherForm, this.responseSeguradora);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/seguradora-form/seguradora-form.component.ts
 **/